import * as $ from 'jquery';
import {Notif} from "@/js/global/components/Notif";

export const authHandler = ()=>{
    $('#login_form').on('submit',async function (e) {
        e.preventDefault();

        const form = $(this);
        const pk = localizedScript.pk;
        const nonce = localizedScript.login_form_nonce;
        const action = localizedScript.login_form_action;

        const token = await grecaptcha.execute(pk, {action: action});

        const password = $('#login_user_password').val();
        if(!password){
            Notif.show('error','Password is required');
            return;
        }

        const $email = $('#login_user_email');
        const email = $email.val();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            Notif.show('error','Email format is invalid');
            return;
        }

        $.ajax({
            url: localizedScript.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: action,
                nonce: nonce,
                recaptcha_token: token,
                email: email,
                password: password
            },

            beforeSend() {
                form.addClass('loading');
            },

            success(response) {
                console.log(response);
                if (response.success) {
                    window.location.reload();
                }else{
                    Notif.show('error',response.data.message);
                }
            },

            complete() {
                form.removeClass('loading');
            }
        });


    })
}